export function trimSpaceAndLowerCase(str) {
  return str ? str?.toLowerCase().replace(/\s+/g, "") : "";
}
